// extracted by mini-css-extract-plugin
export default {"bar":"Filter_bar__1OOZe"};